module.exports = {
          srcSet: __webpack_public_path__ + "964c450c6eec6cf660cd2c964d5d7aaf-49.png"+" 49w",
          images:[ {path: __webpack_public_path__ + "964c450c6eec6cf660cd2c964d5d7aaf-49.png",width: 49,height: 50}],
          src: __webpack_public_path__ + "964c450c6eec6cf660cd2c964d5d7aaf-49.png",
          toString:function(){return __webpack_public_path__ + "964c450c6eec6cf660cd2c964d5d7aaf-49.png"},
          
          width: 49,
          height: 50
        }